import { z } from "zod";

import { AssetSchema } from "../../../schemas/organization";

export const DuplicateAssetRequestPathParamSchema = z.object({
  themeId: z.string(),
});

export type DuplicateAssetRequestPathParamType = z.infer<
  typeof DuplicateAssetRequestPathParamSchema
>;

export const DuplicateAssetRequestBodySchema = z.object({
  sourceKey: z.string(),
  key: z.string(),
});

export type DuplicateAssetRequestBodyType = z.infer<
  typeof DuplicateAssetRequestBodySchema
>;

export const DuplicateAssetResponseBodySchema = z.object({
  asset: AssetSchema,
});

export type DuplicateAssetResponseBodyType = z.infer<
  typeof DuplicateAssetResponseBodySchema
>;
